import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getPortalMigrationDetails } from "../../actions";
/**
 * Contains a mapping of old:new account ids
 * This will only be available during the same page load as a migration.
 */

var migratedAccountsReducer = function migratedAccountsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case getPortalMigrationDetails.SUCCESS_TYPE:
      {
        var _payload$data$financi, _payload$data, _payload$data$financi2, _payload$data$financi3;

        var accountsMapping = (_payload$data$financi = payload === null || payload === void 0 ? void 0 : (_payload$data = payload.data) === null || _payload$data === void 0 ? void 0 : (_payload$data$financi2 = _payload$data.financialPortalById) === null || _payload$data$financi2 === void 0 ? void 0 : (_payload$data$financi3 = _payload$data$financi2.migrationDetails) === null || _payload$data$financi3 === void 0 ? void 0 : _payload$data$financi3.accountsMapping) !== null && _payload$data$financi !== void 0 ? _payload$data$financi : {};
        return _objectSpread(_objectSpread({}, state), accountsMapping);
      }

    default:
      return state;
  }
};

export default migratedAccountsReducer;